import React from "react";
import { connect } from "react-redux";
import _ from "lodash"
import Read from "./Read/Read";
import Info from "./Info/Info";
import Archive from "./Archive/Archive";
import Axios from "Source/axiosPool";
import { showToast } from "Source/globalFunction";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
        notes: store.notes,
        starred:store.starred,
        project: store.project
     };
})
class Actions extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch,selected,notes,loggedUser,handleArchived, starred , isAdmin, project, isAdminWithoutWslead} = this.props;
        const {List} = notes
        const isFavorites =  selected.isStarred
        const handleClose = () => {
            if(this.props.onClose){
                this.props.onClose(isAdmin)
            }
        }
        const path = window.location.href.replace(/^.*[\\\/]/, '')
        const onConversation = path === 'conversations'
    
        return (
            <div class="convo-button-actions">
                {!selected.isArchived &&  <Read  note={selected} onConversation={onConversation} isAdmin={isAdmin}/>}
                <Info onConversation={onConversation} isAdmin={isAdmin}/>
                <Archive  action={handleArchived} note={selected} onConversation={onConversation} isAdmin={isAdmin} isAdminWithoutWslead={isAdminWithoutWslead} />

                <a class={`closeBtn active`} aria-label="Close" onClick={ handleClose }>
                    <i class="material-icons">close</i>
                </a>
            </div>
        );
    }
}

export default Actions;